module.exports = __webpack_public_path__ + "img/phone_img.b632e1e8.png";